import { ddtRow } from './models/ddtRow.model';
import { RowOrdine } from './models/ordine.models';
import { articoloBE, cedola, clienteBE, ddtBE, ordiniBE } from './models/sync.model';
import { config } from './confing';
import { ListItem } from './components/select-items/select-items.component';
/* eslint-disable @typescript-eslint/naming-convention */
// db.ts
import Dexie, { Table } from 'dexie';
import * as _ from 'lodash';
export class AppDB extends Dexie {
  articoli!: Table<articoloBE>;
  autori!: Table<ListItem>;
  editori!: Table<ListItem>;
  collane!: Table<ListItem>;
  clienti!: Table<clienteBE>;
  cedole!: Table<cedola>
  ddt!: Table<ddtRow>;
  ordini!: Table<RowOrdine>;
  prenotazioni!: Table<RowOrdine>;

  constructor(  ) {
    super('ngdexieliveQuery');
    this.version(config.db).stores({
      articoli: 'ean, codice,autore, editore, titolo, collana',
      clienti: 'conto, conto_fatturazione,citta,indirizzo,provincia,cap,telefono,fax,email,primario,secondario,ragione_sociale',
      ddt: 'id, cod_cliente, data_ddt',
      ordini: 'id, cod_cliente, data_ordine',
      prenotazioni: 'id, cod_cliente, data_ordine',
      cedole: 'id, codice_cedola, data_cedola'
    });

  }

  /**
   * Aggiunge la lista autori
   * @param books;
   */
   async addAutori(autori) {
    await db.autori.clear().then(() => {
      db.autori.bulkAdd(autori);
   });
  }
/**
 * aggiunge la lista degli editori,
 * @param editori
 */
   async addEditori(editori)  {
    await db.editori.clear().then(() => {
      db.editori.bulkAdd(editori);
   });
  }

/**
 * aggiunge la lista clienti
 * @param clienti
 */
 async addClienti(clienti) {

  await db.clienti.clear().then((ok) => {
   }).finally(()=> {db.clienti.bulkAdd(clienti);});
  }
/**
 * aggiunge la lista ddt
 * @param ddt
 */
  async addDDT(ddt) {
    await db.ddt.clear().then(() => {
      db.ddt.bulkAdd(ddt);
   });
  }


  /**
   * aggiunge la lista degli ordini
   * @param ordini
   */
  async addOrdini(ordini) {
    await db.ordini.clear().then(() => {
      db.ordini.bulkAdd(ordini);
   });
  }
/**
 * @param prenotazioni
 */
  async addPrenotazioni(prenotazioni) {
    await db.prenotazioni.clear().then(() => {
      db.prenotazioni.bulkAdd(prenotazioni);
   });
  }
/**
 * @param cedole
 */
async addCedole(cedole: Array<cedola>) {
  await db.cedole.clear().then(() => {
    db.cedole.bulkAdd(cedole);
 });
}
/**aggiunge la lista delle collane
 * @param collane
 */
  async addCollane(collane) {
    await db.collane.clear().then(() => {
      db.collane.bulkAdd(collane);
   });
  }

  /**Aggiunge i titoli
   * @param books;
   */
  async addBooks(books) {
    await db.articoli.clear().then(() => {
     db.articoli.bulkAdd(books);
    });
  }
  /**StoreList
   * @param catalogo
   */
  public  getLists(catalogo: Array<articoloBE>,listName: string, groupField: string, fieldValue: string): Array<ListItem> {
    const values: Array<ListItem>= [];
    const Grouped = _.groupBy(catalogo, groupField);
    const a       = Object.keys(Grouped);
    a.forEach((element) => {
      const article: articoloBE = _.find(catalogo, (o) => {
        if (o[groupField]===element) {
          return o;
        }
      });
      values.push({ id: article[groupField], description : article[fieldValue]});
      });
      _.orderBy(values, 'description');
      return values;
  }

async getBudget() {
  return await db.cedole.toArray();
}

/**
 * @param cod_cliente;
 * @returns Promise
 */
  async  getOrdini(cod_cliente: string = null) {
      if (!cod_cliente) {
        return  await db.ordini.toArray();
      }
    return await db.ordini.where('cod_cliente').equals(cod_cliente).toArray();
  }

  async  getPrenotazioni(cod_cliente: string = null) {
    if (!cod_cliente) {
      return  await db.prenotazioni.toArray();
    }
  return await db.prenotazioni.where('cod_cliente').equals(cod_cliente).toArray();
  }

  async getDDT(cod_cliente: string = null) {
      if(!cod_cliente) {
        return await db.ddt.toArray();
      }
      return await db.ddt.where('cod_cliente').equals(cod_cliente).toArray();
  }

  buildRecordSet(table: Table, offset, limit, recordSet = []) {
    const $recordset = table.offset(offset).limit(limit).toArray().then((records) => {
      const merged = _(recordSet) // start sequence
    .keyBy('ean') // create a dictionary of the 1st array
    .merge(_.keyBy(records, 'ean')) // create a dictionary of the 2nd array, and merge it to the 1st
    .values() // turn the combined dictionary to array
    .value(); // get the value (array) out of the sequence
        return merged;
    });
  }
  async  getClienti(cod_cliente: string = null) {
    if (!cod_cliente) {
      return  await db.clienti.toArray();
    }
  return await db.clienti.where('conto').equals(cod_cliente).toArray();
}
}

export const db = new AppDB();
